import React, { useState } from 'react';
import apiClient from '../../services/api/apiClient';
const money = (minor) => (Number(minor) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export default function PayrollCorrectionReview({ employeeId, year, month }) {
  const [preview, setPreview] = useState(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(null);
  const [busy, setBusy] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const run = async (action) => {
    setBusy(true); setError('');
    try { await action(); } catch (err) { setError(err.response?.data?.error?.message || err.message); }
    finally { setBusy(false); }
  };
  const compare = () => run(async () => {
    const result = await apiClient.post('/admin/salary/corrections/preview', { employeeId, year, month });
    setPreview(result.data.data); setSaved(null); setRequestId(window.crypto.randomUUID());
  });
  const record = () => run(async () => {
    const result = await apiClient.post('/admin/salary/corrections/reviews', {
      employeeId, year, month, expectedReviewHash: preview.reviewHash, reason, requestId,
    });
    setSaved(result.data.data);
  });
  return <section>
    <h3>Review a historical rate correction</h3>
    <p>Compare the confirmed payment basis with current dated salary terms using the original work and exchange rate. Recording a review keeps the original payment unchanged. Use its reference for an approved manual adjustment in a later payroll period and in Danløn.</p>
    <button type="button" disabled={busy} onClick={compare}>Compare with current terms</button>
    {error && <p role="alert">{error}</p>}
    {preview && <>
      {preview.blockers?.length > 0 ? <ul>{preview.blockers.map((blocker, index) => <li key={index}>{blocker.code}: {blocker.remediation || blocker.message}</li>)}</ul> : <>
        <p>Original: {money(preview.original.totalDkkMinor)} DKK. Revised: {money(preview.revised.totalDkkMinor)} DKK. Difference: {money(preview.differenceDkkMinor)} DKK.</p>
        <label>Review reason <textarea value={reason} onChange={(event) => setReason(event.target.value)} maxLength={1000} /></label>
        <button type="button" disabled={busy || !!saved || reason.trim().length < 10} onClick={record}>Record correction review</button>
      </>}
      {saved && <p role="status">Correction review saved: {saved.id}. No payment or salary adjustment was made.</p>}
    </>}
  </section>;
}
